import React, { Component } from 'react';
import { Alert, Button, Container } from 'react-bootstrap';
import { recordException } from '../../services/googleServices';

/**
 * ErrorBoundary with Web Crashlytics Integration
 * Catches JavaScript errors anywhere in their child component tree,
 * logs those errors to Google Crashlytics/GA4, and displays a fallback UI.
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    recordException(error, {
      componentStack: errorInfo?.componentStack?.substring(0, 500),
      boundary: this.props.name || 'RootErrorBoundary'
    }, true);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <Container className="my-5 py-4">
          <Alert variant="danger" className="shadow-sm border-0 p-4 rounded-3 text-center">
            <h4 className="alert-heading font-weight-bold mb-3">Something went wrong</h4>
            <p className="mb-2">
              An unexpected application error occurred. The incident has been recorded to Crashlytics telemetry for review.
            </p>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <pre className="text-start bg-dark text-light p-3 rounded mt-3 small" style={{ maxHeight: '200px', overflow: 'auto' }}>
                {this.state.error.toString()}
                {this.state.errorInfo?.componentStack}
              </pre>
            )}
            <hr />
            <div className="d-flex justify-content-center gap-2 mt-3">
              <Button variant="outline-danger" size="sm" onClick={this.handleReset}>
                Try Again
              </Button>
              <Button variant="danger" size="sm" onClick={this.handleReload}>
                Reload Application
              </Button>
            </div>
          </Alert>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

